export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"ErrorCreateConsultation": "Nakorsiartitsiniarnermi ajutoortoqarpoq ",
	"ErrorSendMessage": "Nalunaarummik nassitsiniarnermi ajutoortoqarpoq",
	"Today": "Ullumikkut",
	"ErrorFieldIsMandatory": "Immersuivissaq immersorneqassaaq",
	"ConversationInProgress": "Oqaloqatigiinneq ingerlavoq",
	"IsEmployee": "(sulisoq)",
	"ConversationStartedInfo": " {0} qangiummat takkuppoq",
	"ErrorInvalidEmail": "E-maili atuuttoq inussiarnersumik nalunaarutigeqquneqarpoq.",
	"ErrorInvalidCpr": "CPR-normu atorsinnaanngilaq",
	"Tomorrow": "Aqagu ",
	"ErrorEmailAndOrPhone": "Angiv venligst e-mail og/eller telefonnummer",
	"ErrorUnknown": "Der opstod en ukendt fejl",
	"NameMustBeFilled": "Aqqit piumasaqaataavoq",
	"NameMustOnlyContainLetters": "Aqqa allakkanik kisimi imaqartariaqarpoq"
}